import { BaseModel } from "sjs-base-model";
import SubscribersStatDataItemModel from "./SubscribersStatDataItemModel";
import SubscribersStatSummaryItemModel from "./SubscribersStatSummaryItemModel";

// Returned Api Data sample
// const example = {
//     data: [
//         {
//             SubscriptionId: "4bc1fb2b-eeb9-484d-ad33-dffc07573c29",
//             SubscriptionName: "360T-G10",
//             UserId: "19a482fe-3f6d-4d6f-8fdc-c1a812acf676",
//             Email: "ondrej.sasinka@deutsche-boerse.com",
//             RangeType: "END_UNRESTRICTED",
//             StartDate: 20220101,
//             EndDate: 20221231
//         }
//     ],
//     summary: [
//         {
//             SubscriptionName: "360T-G10",
//             userNumber: 1
//         }
//     ]
// };

export default class SubscribersStatDataModel extends BaseModel {
    data = [SubscribersStatDataItemModel];
    summary = {
        totalSubscriptions: 0,
        summaryData: [SubscribersStatSummaryItemModel]
    };

    constructor(data) {
        super();
        this.update(data);
    }
}
